import { render, staticRenderFns } from "./PisoMenu.vue?vue&type=template&id=7517e7c0&scoped=true"
import script from "./PisoMenu.vue?vue&type=script&lang=js"
export * from "./PisoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7517e7c0",
  null
  
)

export default component.exports